"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = exports.PaymentStatus = exports.Gender = exports.ServiceProviderAvailabilityDayType = exports.AppointmentStatus = exports.Country = exports.PhoneCountryCode = void 0;
var PhoneCountryCode;
(function (PhoneCountryCode) {
    PhoneCountryCode[PhoneCountryCode["Afghanistan"] = 93] = "Afghanistan";
    PhoneCountryCode[PhoneCountryCode["Albania"] = 355] = "Albania";
    PhoneCountryCode[PhoneCountryCode["Algeria"] = 213] = "Algeria";
    PhoneCountryCode[PhoneCountryCode["Andorra"] = 376] = "Andorra";
    PhoneCountryCode[PhoneCountryCode["Angola"] = 244] = "Angola";
    PhoneCountryCode[PhoneCountryCode["Argentina"] = 54] = "Argentina";
    PhoneCountryCode[PhoneCountryCode["Armenia"] = 374] = "Armenia";
    PhoneCountryCode[PhoneCountryCode["Australia"] = 61] = "Australia";
    PhoneCountryCode[PhoneCountryCode["Austria"] = 43] = "Austria";
    PhoneCountryCode[PhoneCountryCode["Azerbaijan"] = 994] = "Azerbaijan";
    PhoneCountryCode[PhoneCountryCode["Bahrain"] = 973] = "Bahrain";
    PhoneCountryCode[PhoneCountryCode["Bangladesh"] = 880] = "Bangladesh";
    PhoneCountryCode[PhoneCountryCode["Belarus"] = 375] = "Belarus";
    PhoneCountryCode[PhoneCountryCode["Belgium"] = 32] = "Belgium";
    PhoneCountryCode[PhoneCountryCode["Belize"] = 501] = "Belize";
    PhoneCountryCode[PhoneCountryCode["Benin"] = 229] = "Benin";
    PhoneCountryCode[PhoneCountryCode["Bhutan"] = 975] = "Bhutan";
    PhoneCountryCode[PhoneCountryCode["Bolivia"] = 591] = "Bolivia";
    PhoneCountryCode[PhoneCountryCode["BosniaAndHerzegovina"] = 387] = "BosniaAndHerzegovina";
    PhoneCountryCode[PhoneCountryCode["Botswana"] = 267] = "Botswana";
    PhoneCountryCode[PhoneCountryCode["Brazil"] = 55] = "Brazil";
    PhoneCountryCode[PhoneCountryCode["Brunei"] = 673] = "Brunei";
    PhoneCountryCode[PhoneCountryCode["Bulgaria"] = 359] = "Bulgaria";
    PhoneCountryCode[PhoneCountryCode["BurkinaFaso"] = 226] = "BurkinaFaso";
    PhoneCountryCode[PhoneCountryCode["Burundi"] = 257] = "Burundi";
    PhoneCountryCode[PhoneCountryCode["Cambodia"] = 855] = "Cambodia";
    PhoneCountryCode[PhoneCountryCode["Cameroon"] = 237] = "Cameroon";
    PhoneCountryCode[PhoneCountryCode["Canada_UnitedStates"] = 1] = "Canada_UnitedStates";
    PhoneCountryCode[PhoneCountryCode["Chad"] = 235] = "Chad";
    PhoneCountryCode[PhoneCountryCode["Chile"] = 56] = "Chile";
    PhoneCountryCode[PhoneCountryCode["China"] = 86] = "China";
    PhoneCountryCode[PhoneCountryCode["Colombia"] = 57] = "Colombia";
    PhoneCountryCode[PhoneCountryCode["CostaRica"] = 506] = "CostaRica";
    PhoneCountryCode[PhoneCountryCode["Croatia"] = 385] = "Croatia";
    PhoneCountryCode[PhoneCountryCode["Cuba"] = 53] = "Cuba";
    PhoneCountryCode[PhoneCountryCode["Cyprus"] = 357] = "Cyprus";
    PhoneCountryCode[PhoneCountryCode["CzechRepublic"] = 420] = "CzechRepublic";
    PhoneCountryCode[PhoneCountryCode["Denmark"] = 45] = "Denmark";
    PhoneCountryCode[PhoneCountryCode["Ecuador"] = 593] = "Ecuador";
    PhoneCountryCode[PhoneCountryCode["Egypt"] = 20] = "Egypt";
    PhoneCountryCode[PhoneCountryCode["ElSalvador"] = 503] = "ElSalvador";
    PhoneCountryCode[PhoneCountryCode["Estonia"] = 372] = "Estonia";
    PhoneCountryCode[PhoneCountryCode["Ethiopia"] = 251] = "Ethiopia";
    PhoneCountryCode[PhoneCountryCode["Finland"] = 358] = "Finland";
    PhoneCountryCode[PhoneCountryCode["France"] = 33] = "France";
    PhoneCountryCode[PhoneCountryCode["Georgia"] = 995] = "Georgia";
    PhoneCountryCode[PhoneCountryCode["Germany"] = 49] = "Germany";
    PhoneCountryCode[PhoneCountryCode["Ghana"] = 233] = "Ghana";
    PhoneCountryCode[PhoneCountryCode["Greece"] = 30] = "Greece";
    PhoneCountryCode[PhoneCountryCode["Guatemala"] = 502] = "Guatemala";
    PhoneCountryCode[PhoneCountryCode["Honduras"] = 504] = "Honduras";
    PhoneCountryCode[PhoneCountryCode["HongKong"] = 852] = "HongKong";
    PhoneCountryCode[PhoneCountryCode["Hungary"] = 36] = "Hungary";
    PhoneCountryCode[PhoneCountryCode["Iceland"] = 354] = "Iceland";
    PhoneCountryCode[PhoneCountryCode["India"] = 91] = "India";
    PhoneCountryCode[PhoneCountryCode["Indonesia"] = 62] = "Indonesia";
    PhoneCountryCode[PhoneCountryCode["Iran"] = 98] = "Iran";
    PhoneCountryCode[PhoneCountryCode["Iraq"] = 964] = "Iraq";
    PhoneCountryCode[PhoneCountryCode["Ireland"] = 353] = "Ireland";
    PhoneCountryCode[PhoneCountryCode["Israel"] = 972] = "Israel";
    PhoneCountryCode[PhoneCountryCode["Italy"] = 39] = "Italy";
    PhoneCountryCode[PhoneCountryCode["Japan"] = 81] = "Japan";
    PhoneCountryCode[PhoneCountryCode["Jordan"] = 962] = "Jordan";
    PhoneCountryCode[PhoneCountryCode["Kazakhstan"] = 7] = "Kazakhstan";
    PhoneCountryCode[PhoneCountryCode["Kenya"] = 254] = "Kenya";
    PhoneCountryCode[PhoneCountryCode["Kuwait"] = 965] = "Kuwait";
    PhoneCountryCode[PhoneCountryCode["Kyrgyzstan"] = 996] = "Kyrgyzstan";
    PhoneCountryCode[PhoneCountryCode["Laos"] = 856] = "Laos";
    PhoneCountryCode[PhoneCountryCode["Latvia"] = 371] = "Latvia";
    PhoneCountryCode[PhoneCountryCode["Lebanon"] = 961] = "Lebanon";
    PhoneCountryCode[PhoneCountryCode["Liberia"] = 231] = "Liberia";
    PhoneCountryCode[PhoneCountryCode["Libya"] = 218] = "Libya";
    PhoneCountryCode[PhoneCountryCode["Lithuania"] = 370] = "Lithuania";
    PhoneCountryCode[PhoneCountryCode["Luxembourg"] = 352] = "Luxembourg";
    PhoneCountryCode[PhoneCountryCode["Macau"] = 853] = "Macau";
    PhoneCountryCode[PhoneCountryCode["Madagascar"] = 261] = "Madagascar";
    PhoneCountryCode[PhoneCountryCode["Malaysia"] = 60] = "Malaysia";
    PhoneCountryCode[PhoneCountryCode["Maldives"] = 960] = "Maldives";
    PhoneCountryCode[PhoneCountryCode["Mali"] = 223] = "Mali";
    PhoneCountryCode[PhoneCountryCode["Malta"] = 356] = "Malta";
    PhoneCountryCode[PhoneCountryCode["Mauritania"] = 222] = "Mauritania";
    PhoneCountryCode[PhoneCountryCode["Mauritius"] = 230] = "Mauritius";
    PhoneCountryCode[PhoneCountryCode["Mexico"] = 52] = "Mexico";
    PhoneCountryCode[PhoneCountryCode["Moldova"] = 373] = "Moldova";
    PhoneCountryCode[PhoneCountryCode["Monaco"] = 377] = "Monaco";
    PhoneCountryCode[PhoneCountryCode["Mongolia"] = 976] = "Mongolia";
    PhoneCountryCode[PhoneCountryCode["Montenegro"] = 382] = "Montenegro";
    PhoneCountryCode[PhoneCountryCode["Morocco"] = 212] = "Morocco";
    PhoneCountryCode[PhoneCountryCode["Mozambique"] = 258] = "Mozambique";
    PhoneCountryCode[PhoneCountryCode["Myanmar"] = 95] = "Myanmar";
    PhoneCountryCode[PhoneCountryCode["Namibia"] = 264] = "Namibia";
    PhoneCountryCode[PhoneCountryCode["Nepal"] = 977] = "Nepal";
    PhoneCountryCode[PhoneCountryCode["Netherlands"] = 31] = "Netherlands";
    PhoneCountryCode[PhoneCountryCode["NewZealand"] = 64] = "NewZealand";
    PhoneCountryCode[PhoneCountryCode["Nicaragua"] = 505] = "Nicaragua";
    PhoneCountryCode[PhoneCountryCode["Nigeria"] = 234] = "Nigeria";
    PhoneCountryCode[PhoneCountryCode["NorthKorea"] = 850] = "NorthKorea";
    PhoneCountryCode[PhoneCountryCode["NorthMacedonia"] = 389] = "NorthMacedonia";
    PhoneCountryCode[PhoneCountryCode["Norway"] = 47] = "Norway";
    PhoneCountryCode[PhoneCountryCode["Oman"] = 968] = "Oman";
    PhoneCountryCode[PhoneCountryCode["Pakistan"] = 92] = "Pakistan";
    PhoneCountryCode[PhoneCountryCode["Panama"] = 507] = "Panama";
    PhoneCountryCode[PhoneCountryCode["Paraguay"] = 595] = "Paraguay";
    PhoneCountryCode[PhoneCountryCode["Peru"] = 51] = "Peru";
    PhoneCountryCode[PhoneCountryCode["Philippines"] = 63] = "Philippines";
    PhoneCountryCode[PhoneCountryCode["Poland"] = 48] = "Poland";
    PhoneCountryCode[PhoneCountryCode["Portugal"] = 351] = "Portugal";
    PhoneCountryCode[PhoneCountryCode["Qatar"] = 974] = "Qatar";
    PhoneCountryCode[PhoneCountryCode["Romania"] = 40] = "Romania";
    PhoneCountryCode[PhoneCountryCode["Russia"] = 7] = "Russia";
    PhoneCountryCode[PhoneCountryCode["Rwanda"] = 250] = "Rwanda";
    PhoneCountryCode[PhoneCountryCode["SaudiArabia"] = 966] = "SaudiArabia";
    PhoneCountryCode[PhoneCountryCode["Senegal"] = 221] = "Senegal";
    PhoneCountryCode[PhoneCountryCode["Serbia"] = 381] = "Serbia";
    PhoneCountryCode[PhoneCountryCode["Singapore"] = 65] = "Singapore";
    PhoneCountryCode[PhoneCountryCode["Slovakia"] = 421] = "Slovakia";
    PhoneCountryCode[PhoneCountryCode["Slovenia"] = 386] = "Slovenia";
    PhoneCountryCode[PhoneCountryCode["SouthAfrica"] = 27] = "SouthAfrica";
    PhoneCountryCode[PhoneCountryCode["SouthKorea"] = 82] = "SouthKorea";
    PhoneCountryCode[PhoneCountryCode["Spain"] = 34] = "Spain";
    PhoneCountryCode[PhoneCountryCode["SriLanka"] = 94] = "SriLanka";
    PhoneCountryCode[PhoneCountryCode["Sudan"] = 249] = "Sudan";
    PhoneCountryCode[PhoneCountryCode["Sweden"] = 46] = "Sweden";
    PhoneCountryCode[PhoneCountryCode["Switzerland"] = 41] = "Switzerland";
    PhoneCountryCode[PhoneCountryCode["Syria"] = 963] = "Syria";
    PhoneCountryCode[PhoneCountryCode["Taiwan"] = 886] = "Taiwan";
    PhoneCountryCode[PhoneCountryCode["Tajikistan"] = 992] = "Tajikistan";
    PhoneCountryCode[PhoneCountryCode["Tanzania"] = 255] = "Tanzania";
    PhoneCountryCode[PhoneCountryCode["Thailand"] = 66] = "Thailand";
    PhoneCountryCode[PhoneCountryCode["Tunisia"] = 216] = "Tunisia";
    PhoneCountryCode[PhoneCountryCode["Turkey"] = 90] = "Turkey";
    PhoneCountryCode[PhoneCountryCode["Turkmenistan"] = 993] = "Turkmenistan";
    PhoneCountryCode[PhoneCountryCode["Uganda"] = 256] = "Uganda";
    PhoneCountryCode[PhoneCountryCode["Ukraine"] = 380] = "Ukraine";
    PhoneCountryCode[PhoneCountryCode["UnitedArabEmirates"] = 971] = "UnitedArabEmirates";
    PhoneCountryCode[PhoneCountryCode["UnitedKingdom"] = 44] = "UnitedKingdom";
    PhoneCountryCode[PhoneCountryCode["Uruguay"] = 598] = "Uruguay";
    PhoneCountryCode[PhoneCountryCode["Uzbekistan"] = 998] = "Uzbekistan";
    PhoneCountryCode[PhoneCountryCode["Venezuela"] = 58] = "Venezuela";
    PhoneCountryCode[PhoneCountryCode["Vietnam"] = 84] = "Vietnam";
    PhoneCountryCode[PhoneCountryCode["Yemen"] = 967] = "Yemen";
    PhoneCountryCode[PhoneCountryCode["Zambia"] = 260] = "Zambia";
    PhoneCountryCode[PhoneCountryCode["Zimbabwe"] = 263] = "Zimbabwe";
})(PhoneCountryCode || (exports.PhoneCountryCode = PhoneCountryCode = {}));
var Country;
(function (Country) {
    Country[Country["Afghanistan"] = 1] = "Afghanistan";
    Country[Country["Albania"] = 2] = "Albania";
    Country[Country["Algeria"] = 3] = "Algeria";
    Country[Country["Andorra"] = 4] = "Andorra";
    Country[Country["Angola"] = 5] = "Angola";
    Country[Country["Argentina"] = 6] = "Argentina";
    Country[Country["Armenia"] = 7] = "Armenia";
    Country[Country["Australia"] = 8] = "Australia";
    Country[Country["Austria"] = 9] = "Austria";
    Country[Country["Azerbaijan"] = 10] = "Azerbaijan";
    Country[Country["Bahrain"] = 11] = "Bahrain";
    Country[Country["Bangladesh"] = 12] = "Bangladesh";
    Country[Country["Belarus"] = 13] = "Belarus";
    Country[Country["Belgium"] = 14] = "Belgium";
    Country[Country["Belize"] = 15] = "Belize";
    Country[Country["Benin"] = 16] = "Benin";
    Country[Country["Bhutan"] = 17] = "Bhutan";
    Country[Country["Bolivia"] = 18] = "Bolivia";
    Country[Country["BosniaAndHerzegovina"] = 19] = "BosniaAndHerzegovina";
    Country[Country["Botswana"] = 20] = "Botswana";
    Country[Country["Brazil"] = 21] = "Brazil";
    Country[Country["Brunei"] = 22] = "Brunei";
    Country[Country["Bulgaria"] = 23] = "Bulgaria";
    Country[Country["BurkinaFaso"] = 24] = "BurkinaFaso";
    Country[Country["Burundi"] = 25] = "Burundi";
    Country[Country["Cambodia"] = 26] = "Cambodia";
    Country[Country["Cameroon"] = 27] = "Cameroon";
    Country[Country["Canada"] = 28] = "Canada";
    Country[Country["Chad"] = 29] = "Chad";
    Country[Country["Chile"] = 30] = "Chile";
    Country[Country["China"] = 31] = "China";
    Country[Country["Colombia"] = 32] = "Colombia";
    Country[Country["CostaRica"] = 33] = "CostaRica";
    Country[Country["Croatia"] = 34] = "Croatia";
    Country[Country["Cuba"] = 35] = "Cuba";
    Country[Country["Cyprus"] = 36] = "Cyprus";
    Country[Country["CzechRepublic"] = 37] = "CzechRepublic";
    Country[Country["Denmark"] = 38] = "Denmark";
    Country[Country["DominicanRepublic"] = 39] = "DominicanRepublic";
    Country[Country["Ecuador"] = 40] = "Ecuador";
    Country[Country["Egypt"] = 41] = "Egypt";
    Country[Country["ElSalvador"] = 42] = "ElSalvador";
    Country[Country["Estonia"] = 43] = "Estonia";
    Country[Country["Ethiopia"] = 44] = "Ethiopia";
    Country[Country["Finland"] = 45] = "Finland";
    Country[Country["France"] = 46] = "France";
    Country[Country["Georgia"] = 47] = "Georgia";
    Country[Country["Germany"] = 48] = "Germany";
    Country[Country["Ghana"] = 49] = "Ghana";
    Country[Country["Greece"] = 50] = "Greece";
    Country[Country["Guatemala"] = 51] = "Guatemala";
    Country[Country["Honduras"] = 52] = "Honduras";
    Country[Country["HongKong"] = 53] = "HongKong";
    Country[Country["Hungary"] = 54] = "Hungary";
    Country[Country["Iceland"] = 55] = "Iceland";
    Country[Country["India"] = 56] = "India";
    Country[Country["Indonesia"] = 57] = "Indonesia";
    Country[Country["Iran"] = 58] = "Iran";
    Country[Country["Iraq"] = 59] = "Iraq";
    Country[Country["Ireland"] = 60] = "Ireland";
    Country[Country["Israel"] = 61] = "Israel";
    Country[Country["Italy"] = 62] = "Italy";
    Country[Country["Jamaica"] = 63] = "Jamaica";
    Country[Country["Japan"] = 64] = "Japan";
    Country[Country["Jordan"] = 65] = "Jordan";
    Country[Country["Kazakhstan"] = 66] = "Kazakhstan";
    Country[Country["Kenya"] = 67] = "Kenya";
    Country[Country["Kuwait"] = 68] = "Kuwait";
    Country[Country["Kyrgyzstan"] = 69] = "Kyrgyzstan";
    Country[Country["Laos"] = 70] = "Laos";
    Country[Country["Latvia"] = 71] = "Latvia";
    Country[Country["Lebanon"] = 72] = "Lebanon";
    Country[Country["Liberia"] = 73] = "Liberia";
    Country[Country["Libya"] = 74] = "Libya";
    Country[Country["Lithuania"] = 75] = "Lithuania";
    Country[Country["Luxembourg"] = 76] = "Luxembourg";
    Country[Country["Macau"] = 77] = "Macau";
    Country[Country["Madagascar"] = 78] = "Madagascar";
    Country[Country["Malaysia"] = 79] = "Malaysia";
    Country[Country["Maldives"] = 80] = "Maldives";
    Country[Country["Mali"] = 81] = "Mali";
    Country[Country["Malta"] = 82] = "Malta";
    Country[Country["Mauritania"] = 83] = "Mauritania";
    Country[Country["Mauritius"] = 84] = "Mauritius";
    Country[Country["Mexico"] = 85] = "Mexico";
    Country[Country["Moldova"] = 86] = "Moldova";
    Country[Country["Monaco"] = 87] = "Monaco";
    Country[Country["Mongolia"] = 88] = "Mongolia";
    Country[Country["Montenegro"] = 89] = "Montenegro";
    Country[Country["Morocco"] = 90] = "Morocco";
    Country[Country["Mozambique"] = 91] = "Mozambique";
    Country[Country["Myanmar"] = 92] = "Myanmar";
    Country[Country["Namibia"] = 93] = "Namibia";
    Country[Country["Nepal"] = 94] = "Nepal";
    Country[Country["Netherlands"] = 95] = "Netherlands";
    Country[Country["NewZealand"] = 96] = "NewZealand";
    Country[Country["Nicaragua"] = 97] = "Nicaragua";
    Country[Country["Nigeria"] = 98] = "Nigeria";
    Country[Country["NorthKorea"] = 99] = "NorthKorea";
    Country[Country["NorthMacedonia"] = 100] = "NorthMacedonia";
    Country[Country["Norway"] = 101] = "Norway";
    Country[Country["Oman"] = 102] = "Oman";
    Country[Country["Pakistan"] = 103] = "Pakistan";
    Country[Country["Panama"] = 104] = "Panama";
    Country[Country["Paraguay"] = 105] = "Paraguay";
    Country[Country["Peru"] = 106] = "Peru";
    Country[Country["Philippines"] = 107] = "Philippines";
    Country[Country["Poland"] = 108] = "Poland";
    Country[Country["Portugal"] = 109] = "Portugal";
    Country[Country["Qatar"] = 110] = "Qatar";
    Country[Country["Romania"] = 111] = "Romania";
    Country[Country["Russia"] = 112] = "Russia";
    Country[Country["Rwanda"] = 113] = "Rwanda";
    Country[Country["SaudiArabia"] = 114] = "SaudiArabia";
    Country[Country["Senegal"] = 115] = "Senegal";
    Country[Country["Serbia"] = 116] = "Serbia";
    Country[Country["Singapore"] = 117] = "Singapore";
    Country[Country["Slovakia"] = 118] = "Slovakia";
    Country[Country["Slovenia"] = 119] = "Slovenia";
    Country[Country["SouthAfrica"] = 120] = "SouthAfrica";
    Country[Country["SouthKorea"] = 121] = "SouthKorea";
    Country[Country["Spain"] = 122] = "Spain";
    Country[Country["SriLanka"] = 123] = "SriLanka";
    Country[Country["Sudan"] = 124] = "Sudan";
    Country[Country["Sweden"] = 125] = "Sweden";
    Country[Country["Switzerland"] = 126] = "Switzerland";
    Country[Country["Syria"] = 127] = "Syria";
    Country[Country["Taiwan"] = 128] = "Taiwan";
    Country[Country["Tajikistan"] = 129] = "Tajikistan";
    Country[Country["Tanzania"] = 130] = "Tanzania";
    Country[Country["Thailand"] = 131] = "Thailand";
    Country[Country["Tunisia"] = 132] = "Tunisia";
    Country[Country["Turkey"] = 133] = "Turkey";
    Country[Country["Turkmenistan"] = 134] = "Turkmenistan";
    Country[Country["Uganda"] = 135] = "Uganda";
    Country[Country["Ukraine"] = 136] = "Ukraine";
    Country[Country["UnitedArabEmirates"] = 137] = "UnitedArabEmirates";
    Country[Country["UnitedKingdom"] = 138] = "UnitedKingdom";
    Country[Country["UnitedStates"] = 139] = "UnitedStates";
    Country[Country["Uruguay"] = 140] = "Uruguay";
    Country[Country["Uzbekistan"] = 141] = "Uzbekistan";
    Country[Country["Venezuela"] = 142] = "Venezuela";
    Country[Country["Vietnam"] = 143] = "Vietnam";
    Country[Country["Yemen"] = 144] = "Yemen";
    Country[Country["Zambia"] = 145] = "Zambia";
    Country[Country["Zimbabwe"] = 146] = "Zimbabwe";
})(Country || (exports.Country = Country = {}));
var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus[AppointmentStatus["Pending"] = 1] = "Pending";
    AppointmentStatus[AppointmentStatus["Confirmed"] = 2] = "Confirmed";
    AppointmentStatus[AppointmentStatus["Canceled"] = 3] = "Canceled";
    AppointmentStatus[AppointmentStatus["Completed"] = 4] = "Completed";
})(AppointmentStatus || (exports.AppointmentStatus = AppointmentStatus = {}));
var ServiceProviderAvailabilityDayType;
(function (ServiceProviderAvailabilityDayType) {
    ServiceProviderAvailabilityDayType[ServiceProviderAvailabilityDayType["PrivateAccess"] = 1] = "PrivateAccess";
    ServiceProviderAvailabilityDayType[ServiceProviderAvailabilityDayType["PublicAccess"] = 2] = "PublicAccess";
    // Both = 3,
})(ServiceProviderAvailabilityDayType || (exports.ServiceProviderAvailabilityDayType = ServiceProviderAvailabilityDayType = {}));
var Gender;
(function (Gender) {
    Gender[Gender["Female"] = 1] = "Female";
    Gender[Gender["Male"] = 2] = "Male";
    Gender[Gender["Other"] = 3] = "Other";
})(Gender || (exports.Gender = Gender = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["Pending"] = 1] = "Pending";
    PaymentStatus[PaymentStatus["Completed"] = 2] = "Completed";
    PaymentStatus[PaymentStatus["Failed"] = 3] = "Failed";
    PaymentStatus[PaymentStatus["Refunded"] = 4] = "Refunded";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["CreditCard"] = 1] = "CreditCard";
    PaymentMethod[PaymentMethod["Paypal"] = 2] = "Paypal";
    PaymentMethod[PaymentMethod["Cash"] = 3] = "Cash";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
